import { ActiveFilterName, SCPlayersActiveFilterName, H2HActiveFilterName, SCLineupPlayersActiveFilterName } from "@ihs-widget/utils/enums";
import { createContext } from "react";


const DefaultActiveFilter = {
    ALL: 'All',
    FIRST_HALF: '1st Half',
    SECOND_HALF: '2nd Half'// TODO: we can get it from defaulttranslations?
} as const;
type DefaultActiveFilter = (typeof DefaultActiveFilter)[keyof typeof DefaultActiveFilter]

type DefaultActiveFilterKey = keyof typeof DefaultActiveFilter;

const DefaultSCPlayersActiveFilter = {
    GOALS: 'Goals',
    ASSISTS: 'Assists',
    CARDS: 'Cards',
    SHOTS: 'Shots',// TODO: we can get it from defaulttranslations?
} as const;
type DefaultSCPlayersActiveFilter = (typeof DefaultSCPlayersActiveFilter)[keyof typeof DefaultSCPlayersActiveFilter]

type DefaultSCPlayersActiveFilterKey = keyof typeof DefaultSCPlayersActiveFilter;

const DefaultH2HActiveFilter = {
    H2H: 'H2H',
    TABLE: 'TABLE',
    QUARTER_FINALS: 'QUARTER_FINALS',
    ROUND_OF_16: 'ROUND_OF_16',
    KNOCKOUT: 'KNOCKOUT',
    QUALIFICATION: 'QUALIFICATION',
    GROUPS_TABLES: 'GROUPS_TABLES',
} as const;
type DefaultH2HActiveFilter = (typeof DefaultH2HActiveFilter)[keyof typeof DefaultH2HActiveFilter]

type DefaultH2HActiveFilterKey = keyof typeof DefaultH2HActiveFilter;

const DefaultSCLineupPlayersActiveFilter = {
    XGOALS: 'xGoals',
    SHOTS: 'Shots',
    BALL_TOUCHES: 'Ball Touches', // TODO: we can get it from defaulttranslations?
    NULL: '',
} as const;
type DefaultSCLineupPlayersActiveFilter = (typeof DefaultSCLineupPlayersActiveFilter)[keyof typeof DefaultSCLineupPlayersActiveFilter]

type DefaultSCLineupPlayersActiveFilterKey = keyof typeof DefaultSCLineupPlayersActiveFilter;

export interface IState {
    statsTabActiveFilter: DefaultActiveFilterKey; 
    statsTabActiveFilterName: ActiveFilterName;
    playersTabActiveFilter: DefaultSCPlayersActiveFilterKey;
    playersTabActiveFilterName: SCPlayersActiveFilterName;
    lineupTabActiveFilter: DefaultSCLineupPlayersActiveFilterKey;
    lineupTabActiveFilterName: SCLineupPlayersActiveFilterName;
    h2hTabActiveFilter: DefaultH2HActiveFilterKey;
    h2hTabActiveFilterName: H2HActiveFilterName;
    h2hTabIsOpenLast5Meetings: boolean;
    overviewEventAndTimeWidth: number;
    activeTooltipPlayerId: string | null;
    scrollPositions: {
        [key: string]: number;
    };
    statsConsoleIframeWidth: number | null;
    screenWidth: number | null;
}

export interface ICfgContextProps {
    stContext: IState;
    setStContext: any;
}

export const initialStateContext: IState = {
    statsTabActiveFilter: Object.keys(DefaultActiveFilter)[0] as DefaultActiveFilterKey,
    statsTabActiveFilterName: ActiveFilterName.FULL_MATCH,
    playersTabActiveFilter: Object.keys(DefaultSCPlayersActiveFilter)[0] as DefaultSCPlayersActiveFilterKey,
    playersTabActiveFilterName: SCPlayersActiveFilterName.GOALS,
    lineupTabActiveFilter: Object.keys(DefaultSCLineupPlayersActiveFilter)[3] as DefaultSCLineupPlayersActiveFilterKey,
    lineupTabActiveFilterName: SCLineupPlayersActiveFilterName.NULL,
    h2hTabActiveFilter: Object.keys(DefaultH2HActiveFilter)[0] as DefaultH2HActiveFilterKey,
    h2hTabActiveFilterName: H2HActiveFilterName.H2H,
    h2hTabIsOpenLast5Meetings: false,
    overviewEventAndTimeWidth: 16,
    activeTooltipPlayerId: null,
    scrollPositions: {},
    statsConsoleIframeWidth: null,
    screenWidth: typeof window !== 'undefined' ? window.innerWidth : null,
}

export const StateContext = createContext<ICfgContextProps | null>(null);
